import { render, staticRenderFns } from "./TrademarkObjectionToUsDecisionList.vue?vue&type=template&id=6212c32b&"
import script from "./TrademarkObjectionToUsDecisionList.vue?vue&type=script&lang=js&"
export * from "./TrademarkObjectionToUsDecisionList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkObjectionToUsDecisionList.vue?vue&type=style&index=0&id=6212c32b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports